import { mapState } from "vuex";
export default {
    computed: {
        ...mapState([
            "organicProducts",
            "conventionalProducts",
            "productDetails"
        ]),
        organicProductList: {
            get() {
                return this.organicProducts;
            },
            set(value) {
                this.$store.commit("updateOrganicProducts", value);
            }
        },
        conventionalProductList: {
            get() {
                return this.conventionalProducts;
            },
            set(value) {
                this.$store.commit("updateConventionalProducts", value);
            }
        },
        productInfo: {
            get() {
                return this.productDetails;
            },
            set(value) {
                this.$store.commit("updateProductDetails", value);
            }
        },
    },
    methods: {
        handleImageError(event) {
            event.target.src = '/assets/img/empty.jpg';
        },
        getProductBySlug(slug) {
            axios.get(`/api/product/bySlug/${slug}`)
            .then(response => {
                let productInfo = response.data;
                if(productInfo[0]) {
                    this.productInfo = productInfo[0];
                }
            }).catch(error => {
                console.error(error);
            })
        }
    }
}